export const AssessmentCalc = ({ value, record }) => record.result?.assessmentCalc != null ? ( (!!record.result?.assessmentCalc) ? 'Ja' : 'Nein' ) : ''
